import { isSecondaryBlockOpened } from './payment';
import { i18n } from '@/commons/utils';

export function Homebanking() {
  this.init = function init(_params) {
    this.container = _params.container;
    this.parent = _params.parent;

    this.state = {
      selected: _params.selected || false
    };

    this.props = {
      isExpress: _params.isExpress || false,
      isCheckout: _params.isCheckout || false,
      orderId: _params.orderId,
      multiEnabled: (this.container.getAttribute('data-multi-enabled') === 'true'),
      paymentTypeId: this.container.getAttribute('data-payment-type-id')
    };

    this.elements = {};
    if (this.props.isExpress === false) {
      this.elements.header = this.container.querySelector('.dkt-block-header');
      this.elements.content = this.container.querySelector('.dkt-block-content');
    } else {
      this.elements.content = this.container;
    }

    if (this.elements.content) {
      this.render();
    }

    if (this.state.selected === true) {
      this.select();
    }
    this.events();
  };
}

Homebanking.prototype.render = function render() {
  this.elements.content.innerHTML = `<p class="dkt-description" data-tnr-homebanking-description>${i18n('payment.primary.description.OGONE_-_HOMEBANKING')}</p>
    <ul class="dkt-homebanking" data-tnr-homebanking-logos>
      <li><img class="dkt-homebanking__logo" src="/assets/images/payment/homebanking/ing.svg" alt="ING"/></li>
      <li><img class="dkt-homebanking__logo" src="/assets/images/payment/homebanking/belfius.svg" alt="Belfius"/></li>
      <li><img class="dkt-homebanking__logo" src="/assets/images/payment/homebanking/kbc.svg" alt="KBC"/></li>
      <li><img class="dkt-homebanking__logo" src="/assets/images/payment/homebanking/cbc.svg" alt="CBC"/></li>
    </ul>`;
};

Homebanking.prototype.events = function events() {
  document.addEventListener('clickedOnPay', () => this.checkPayment());
  document.addEventListener('PrimaryPaymentBlockSelected', () => this.unselect());
  if (this.props.isCheckout === true) {
    this.elements.header.addEventListener('click', event => this.select(event));
  }
};

Homebanking.prototype.select = function select(event) {
  if ((this.state.selected === false && event) || !event) {
    document.dispatchEvent(new CustomEvent('PrimaryPaymentBlockSelected', {
      bubbles: false,
      cancelable: false,
      detail: {
        'multiEnabled': this.props.multiEnabled
      }
    }));
    $(this.elements.content).slideDown('fast', () => this.displaySelect());
    this.state.selected = true;
    if (this.props.isExpress === false && this.parent.enableButton) {
      this.parent.enableButton();
    }
  }
};

Homebanking.prototype.unselect = function unselect() {
  $(this.elements.content).slideUp('normal', () => this.displayUnselect());
  this.state.selected = false;
};

Homebanking.prototype.displaySelect = function displaySelect() {
  this.container.classList.add('dkt-block--selected');
  this.container.classList.add('dkt-block--open');
};

Homebanking.prototype.displayUnselect = function displayUnselect() {
  this.container.classList.remove('dkt-block--selected');
  this.container.classList.remove('dkt-block--open');
};

Homebanking.prototype.checkPayment = function checkPayment() {
  if (this.state.selected === true) {
    if (this.parent.checkTermsOfUse && this.parent.checkTermsOfUse() === false) {
      return;
    }

    if (this.props.isCheckout) {
      if (this.parent.checkBillingAddress && this.parent.checkBillingAddress() === false) {
        return;
      }
      if (this.parent.isFullSecondaryPayment && this.parent.isFullSecondaryPayment() === true) {
        return;
      }
    }
    this.submitPayment();
  }
};

Homebanking.prototype.submitPayment = function submitPayment() {
  const params = {
    paymentTypeId: this.props.paymentTypeId,
    redirectionUrl: document.getElementById('redirectionUrl').value,
    pspRedirectionUrl: document.getElementById('pspRedirectionUrl').value,
    orderAttributes: JSON.stringify(this.parent.getAnalyticsInfos()),
    orderId: this.props.orderId,
    paymentUrl: document.getElementById('paymentUrl').value
  };

  params.useSecondaryMop = isSecondaryBlockOpened();

  if (this.parent.displayLoader) {
    this.parent.displayLoader();
  }

  cube.ajax.post('rest/model/com/decathlon/cube/commerce/payment/PaymentActor/applyPayment', params)
    .onSuccess(response => this.submitPaymentSuccess(response))
    .onError(() => this.submitPaymentError())
    .call();
};

Homebanking.prototype.submitPaymentSuccess = function submitPaymentSuccess(response) {
  if (response && response.result && response.result.data) {
    const { data } = response.result;
    if (data !== false && data.redirectPspForm) {
      const formElement = document.createElement('div');
      formElement.style.display = 'none';
      formElement.innerHTML = data.redirectPspForm;
      this.container.appendChild(formElement);
      const form = formElement.querySelector('form');
      form.submit();
      if (window.cube.config.anly_useLegacy === 'Y') {
        CUBE.Analytics.queue.send('proceedToConfirmation');
      }
    } else {
      this.parent.displayError(response.responseTO.errors[0].message);
    }
  } else {
    if (this.parent.hideLoader) {
      this.parent.hideLoader();
    }
    this.parent.displayError(response.responseTO.errors[0].message);
  }
};

Homebanking.prototype.submitPaymentError = function submitPaymentError() {
  if (this.parent.hideLoader) {
    this.parent.hideLoader();
  }
  if (this.parent.displayError) {
    this.parent.displayError(i18n('TECH_0001'));
  }
};



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-homebanking.js